import { AuthContextProvider } from '@streamelements/client-sdk-js';

export async function createUserScopedStorageContainerItemInfo({
  authContextProvider,
  itemId,
}: {
  authContextProvider: AuthContextProvider;
  itemId: string;
}) {
  const {
    channel: { _id: channelId },
  } = await authContextProvider.getAuthContext();

  return {
    container: channelId,
    scope: 'streamelements_multi-streaming',
    item: itemId,
  };
}
